import dayjs from 'dayjs';

export function clientDaySeries(rows, from, to) {
    const start = dayjs(from);
    const end = dayjs(to);
    if (!start.isValid() || !end.isValid() || end.isBefore(start, 'day')) return { days: [], series: [] };
    const byDate = new Map();
    for (const row of rows || []) {
        if (!row?.shootDate) continue;
        const grossByClient = new Map();
        for (const client of row.byClient || []) {
            if (!client.companyCode) continue;
            grossByClient.set(client.companyCode, Number(client.gross) || 0);
        }
        byDate.set(row.shootDate, grossByClient);
    }
    const days = [];
    for (let cursor = start; !cursor.isAfter(end, 'day'); cursor = cursor.add(1, 'day')) {
        days.push(cursor.format('YYYY-MM-DD'));
    }
    const totals = new Map();
    for (const day of days) {
        for (const [code, gross] of byDate.get(day) || []) {
            totals.set(code, (totals.get(code) || 0) + gross);
        }
    }
    const series = [...totals.entries()]
        .filter(([, total]) => total > 0)
        .sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]))
        .map(([client]) => ({
            client,
            points: days.map(day => (byDate.get(day) || new Map()).get(client) || 0),
        }));
    return { days, series };
}
